import axios from 'axios';
import { DEFAULT_SMART_TALK_API_URL } from './shared/utils/constants';
import { getToken } from './auth';

const smarttalkaxios = () => {
  return axios.create({
    baseURL: DEFAULT_SMART_TALK_API_URL,
    headers: {
      Authorization: getToken(),
    },
  });
};

export default smarttalkaxios;
